<template>
  <v-menu
    class="mt-2 ml-5"
    :close-on-content-click="false"
    min-width="0"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-row align="center" no-gutters>
        <v-col cols="12" md="2" class="text-center">
          <v-btn
            :color="level.color"
            :class="[
              `${getTextColor(level.color)}--text`
            ]"
            small
            dark
            rounded
            v-bind="attrs"
            v-on="on"
          >
            Выбрать цвет
          </v-btn>
        </v-col>
        <v-col cols="12" md="2">
          <v-text-field
            v-model.number="level.threshold"
            :rules="rules.threshold"
            type="text"
            label="Минимальное значение для цвета"
          />
        </v-col>
      </v-row>
    </template>

    <v-card>
      <v-color-picker
        v-model="level.color"
        flat
      />
    </v-card>
  </v-menu>
</template>

<script>
import getTextColor from '@/utils/get-text-color';

export default {
  name: 'object-view-settings-voronoi',
  props: {
    level: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      rules: {
        threshold: [
          v => v !== '' || 'Не указано значение',
          v => !Number.isNaN(Number(v)) || 'Должно быть числовое значение',
        ],
      },
    };
  },

  methods: {
    getTextColor(i) {
      if (!i) return 'white';
      return getTextColor(i);
    },
  },
};
</script>

<style>

</style>
